import React from 'react';
import DeviceTable from './compnents/devices-table/devices-table';

const DigitalSignageDevices: React.FC = () => {
  return (
    <div className="w-full h-full">
      <DeviceTable />
    </div>
  );
};

export default DigitalSignageDevices;
